export default __webpack_public_path__ + "img/4790f3295684233f5cb85e0099c92b98.png";